import { render, staticRenderFns } from "./Singup.vue?vue&type=template&id=8f625380&"
import script from "./Singup.vue?vue&type=script&lang=js&"
export * from "./Singup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports